export default __webpack_public_path__ + "static/media/flashingarc2.317651a8.png";